module.exports = __webpack_public_path__ + "static/media/code-logo.8f0c3378.svg";